'use strict';
const mmWidgets = require('./mm-widgets');

require('./section-handler-widget');
require('./show-error');
require('./show-progress-message');

mmWidgets.fn.personalSignupWidget = function (authenticationModel, subscriptionModel, subscriptionPlanModel, context) {
	return this.each(function () {
		const widget = this.sectionHandlerWidget(),
			contextApplicableSections = ['register', 'buySubscription', 'subscriptionPurchased'],
			sectionName = (withoutContext) => {
				if (!context || !contextApplicableSections.includes(withoutContext)) {
					return withoutContext;
				}
				return `${context}-${withoutContext}`;
			},
			hideErrors = function () {
				widget.find(`[data-mm-section~="${sectionName('register')}"] .error`).addClass('hidden');
			},
			showRegistration = function () {
				hideErrors();
				widget.showSection(sectionName('register'));
				widget.find('[name="registration-account-name"]').focus();
			},
			showCompleted = function (goldAccountInfo) {
				if (goldAccountInfo.purchaseComplete) {
					widget.showSection(sectionName('subscriptionPurchased'));
				} else if (goldAccountInfo && goldAccountInfo.license && goldAccountInfo.license.account === goldAccountInfo.domain) {
					widget.showSection('activeDomainSubscription');
				} else {
					widget.showSection('activePersonalSubscription');
				}
			},
			showPurchaseOption = (goldAccountInfo) => {
				const actions = goldAccountInfo && goldAccountInfo.subscription && goldAccountInfo.subscription.actions;
				subscriptionPlanModel.filterPlans(actions);
				if (subscriptionPlanModel.availablePlans().length === 0) {
					return 'noPlansAvailable';
				} if (actions && actions.length && (actions.includes('BuySubscription') || actions.includes('BuyTeamSubscription'))) {
					return sectionName('buySubscription');
				} else if (actions && actions.length && actions.includes('BuyDomainSubscription')) {
					return 'buyDomainSubscription';
				}
				return false;
			},
			showAccountInfo = function (goldAccountInfo) {
				const purchaseOption = showPurchaseOption(goldAccountInfo);
				if (purchaseOption) {
					widget.showSection(purchaseOption);
				} else {
					showCompleted(goldAccountInfo);
				}
			},
			loadGoldAccountDetails = function () {
				return subscriptionModel.getGoldAccountDetails(true)
				.then(showAccountInfo)
				.catch((reason) => {
					if (['not-authenticated', 'not-registered'].indexOf(reason) >= 0) {
						showRegistration();
					} else {
						widget.showError(reason);
					}
				});
			};

		subscriptionModel.addEventListener('showPersonalAccountSignup accountRegistered', () => {
			hideErrors();
			widget.removeClass('hidden');
			widget.showProgressMessage('Checking account information');
			widget.trigger('reset');
			loadGoldAccountDetails();
			widget.trigger('subscription-handler-complete');
		});
		subscriptionModel.addEventListener('goldAccountInfo', (goldAccountInfo) => {
			if (goldAccountInfo.active) {
				showCompleted(goldAccountInfo);
			}
		});
		authenticationModel.addEventListener('retrievingSubscription', () => {
			widget.showProgressMessage('Loading account details...');
		});
	});
};
